import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { injectIntl, defineMessages } from 'react-intl';

import * as common from 'libs/commonFunc';
import { Button, Image, Icon, Message } from 'semantic-ui-react';
import { ReduxFormField } from 'components';

import classNames from 'classnames/bind';
import styles from './SmtpTest.css';
const cx = classNames.bind(styles);

class SmtpTest extends PureComponent {
  constructor(props) {
    super(props);

    const { value } = props.mailSmtpTested;

    this.state = { visible: value === '1' ? false : true };
  }

  componentWillReceiveProps(nextProps) {
    const { onProgress } = this.props;

    if (!nextProps.onProgress && onProgress !== nextProps.onProgress) {
      this.setState({ visible: true });
    }
  }

  handleDismiss = () => {
    this.setState({ visible: false });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { visible } = this.state;
    const { mailSmtpTested, checkSmtp, onProgress } = this.props;
    const { value, paramOptions } = mailSmtpTested;
    let testInfo = paramOptions;
    if (typeof testInfo === 'undefined') {
      testInfo = {};
    }
    const { checkSuccessEpoch, checkFailEpoch, needReCheck, log } = testInfo;

    return (
      <div className={cx('smtp-test-box')}>
        <div className={cx('bt-smtp-test-area')}>
          <Button
            className={cx('bt-smtp-test', 'bt-style-gleam common-button-brand')}
            size="small"
            loading={onProgress}
            disabled={onProgress}
            content={defineMessages(formatMessage({ id: 'SmtpTest_1', defaultMessage: '연결 테스트' }))}
            onClick={checkSmtp}
          />
        </div>
        {visible &&
          value !== '0' && (
            <div>
              <div className={cx('connecting-row')}>
                {value === '1' ? (
                  <div className={cx('connecting-text')}>
                    <Image src="/img/examStart/ico_check.png" />
                    {defineMessages(formatMessage({ id: 'SmtpTest_2', defaultMessage: '연결에 성공하였습니다.' })) +
                      (!!checkSuccessEpoch ? ' (' + common.timeFormatFromUTCEpoch(checkSuccessEpoch) + ')' : '')}
                  </div>
                ) : (
                  <div className={cx('connecting-text')}>
                    <Image src="/img/examStart/ico_fail.png" />
                    {defineMessages(formatMessage({ id: 'SmtpTest_3', defaultMessage: '연결에 실패하였습니다.' })) +
                      (!!checkFailEpoch ? ' (' + common.timeFormatFromUTCEpoch(checkFailEpoch) + ')' : '')}
                  </div>
                )}
              </div>
              {!!needReCheck && (
                <div className={cx('smtp-test-comment', 'inline-block')}>
                  {defineMessages(
                    formatMessage({
                      id: 'SmtpTest_4',
                      defaultMessage: '마지막 연결 테스트 이후에 설정을 변경하였습니다. 다시 테스트 해보세요.'
                    })
                  )}
                </div>
              )}
            </div>
          )}
      </div>
    );
  }
}

SmtpTest.propTypes = {
  paramOptions: PropTypes.object
};
SmtpTest.defaultProps = {
  paramOptions: {}
};

export default injectIntl(SmtpTest);



// WEBPACK FOOTER //
// ./src/script/components/config/SmtpTest.js